import _ from 'lodash';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/index';

const store = createStore(
    rootReducer,
    compose(
        applyMiddleware(thunk),
        window.devToolsExtension ? window.devToolsExtension() : f => f
    )
);

const saveConfigToLocalStorage = _.debounce(() => {
    const configurator = store.getState().configurator;
    if (!configurator.penSlug) {
        return;
    }
    localStorage.setItem(configurator.penSlug, JSON.stringify(configurator.config));
}, 200);

store.subscribe(() => {
    saveConfigToLocalStorage();
});

export default store;
